import {
  Drama, Sparkles, CupSoda, Bean, CookingPot, Cookie, Carrot, Flame, Scissors, House, Candy, Wheat, Droplets, Layers,
} from "lucide-react";

const GOLD = "bg-ochre/20 text-[#8a5a00]";
const RED = "bg-clay/10 text-clay";
const GREEN = "bg-leaf/15 text-forest";
const INK = "bg-ink/5 text-ink";

// Icon + tint per category, matched on the normalised name (e.g. "Food-Cooked" -> "foodcooked").
const CATEGORY_ICONS = {
  artifacts: [Drama, GOLD],
  beauty: [Sparkles, RED],
  drink: [CupSoda, RED], beverages: [CupSoda, RED],
  dryfoods: [Bean, GOLD],
  foodcooked: [CookingPot, GREEN], foodcookedtribes: [CookingPot, GREEN],
  foodsnack: [Cookie, GOLD], foodsnacks: [Cookie, GOLD], snacks: [Cookie, GOLD],
  fooduncooked: [Carrot, GREEN], freshproduce: [Carrot, GREEN],
  foodspice: [Flame, RED], spiceuncooked: [Flame, RED], spicesseasonings: [Flame, RED],
  hair: [Scissors, INK],
  householditem: [House, INK],
  sweet: [Candy, RED],
  grainsflour: [Wheat, GOLD],
  pantryoils: [Droplets, GREEN],
};

// Returns [IconComponent, tintClasses]; unknown categories fall back to a generic stack icon.
export const categoryIcon = (name) =>
  CATEGORY_ICONS[(name || "").toLowerCase().replace(/[^a-z0-9]+/g, "")] || [Layers, GREEN];
